export default "__VITE_ASSET__BMa_pleT__"